export const desiredStatePolicies = [
  {
    Name: "Default Corporate Build",
    Description: "Nessus LAPS and PSH5",
    Type: "Server",
  },
  {
    Name: "High Risk Servers",
    Description: "FedRAMP/Carbon black HIGH settings",
    Type: "Server",
  },
  {
    Name: "DEV/QA Servers",
    Description: "Ensure QA toolkit are always installed",
    Type: "Server",
  },
  {
    Name: "OLD DEV Server Policy",
    Description: "Deploy QA and debugging toolkits",
    Type: "Server",
  },
];

export const desiredStateRules = [
  {
    ComplianceSeverity: "HIGH",
    Parameters: {
      ChefClientVersion: ["11"],
      SourceType: ["GITHUB"],
    },
    Platform: "Cross-Platform",
    Remediation: {
      Enabled: false,
      Parameters: {
        commands: [],
        executionTimeout: [],
        workingDirectory: [],
      },
      Type: "AWS-RunPowerShellScript",
    },
    RuleId: "1a6196f6-5425-445d-8f4b-cd1aff65b04e",
    RuleName: "Apply DevOps based playbook",
    RuleType: "Apply Chef Recipe",
    Type: "AWS-ApplyChefRecipes",
    parameterMetaData: [
      {
        "AWS-ApplyChefRecipesSourceTypeValue": "GITHUB",
        Name: "SourceType",
      },
      null,
      null,
      null,
      {
        "AWS-ApplyChefRecipesChefClientVersionValue": "11",
        Name: "ChefClientVersion",
      },
    ],
    remediationEnabled: false,
    remediationScript: {},
    windowsScript: true,
  },
  {
    ComplianceSeverity: "LOW",
    Parameters: {
      Check: ["True"],
      InstallDependencies: ["False"],
      SourceType: ["S3"],
      Verbose: ["-v"],
    },
    Platform: "Linux",
    Remediation: {
      Enabled: false,
      Parameters: {
        commands: [],
        executionTimeout: [],
        workingDirectory: [],
      },
      Type: "AWS-RunShellScript",
    },
    RuleId: "a86b6539-bcf5-4179-8478-8b6c29274d67",
    RuleName: "Ansible playbook",
    RuleType: "Apply Ansible Playbook",
    Type: "AWS-ApplyAnsiblePlaybooks",
    parameterMetaData: [
      {
        "AWS-ApplyAnsiblePlaybooksSourceTypeValue": "S3",
        Name: "SourceType",
      },
      null,
      {
        "AWS-ApplyAnsiblePlaybooksInstallDependenciesValue": "False",
        Name: "InstallDependencies",
      },
      null,
      null,
      {
        "AWS-ApplyAnsiblePlaybooksCheckValue": "True",
        Name: "Check",
      },
      {
        "AWS-ApplyAnsiblePlaybooksVerboseValue": "-v",
        Name: "Verbose",
      },
    ],
    remediationEnabled: false,
    remediationScript: {},
    windowsScript: false,
  },
  {
    ComplianceSeverity: "HIGH",
    Parameters: {
      commands: [
        "$Location='C:\\files'",
        "If (!(Test-Path $Location -PathType leaf)) {",
        '[Environment]::Exit("1");',
        "}",
        "else",
        "{",
        '[Environment]::Exit("0");',
        "}",
      ],
    },
    Platform: "Cross-Platform",
    Remediation: {
      Enabled: true,
      Parameters: {
        commands: ["cd .."],
        executionTimeout: ["1"],
        workingDirectory: [],
      },
      Type: "AWS-RunPowerShellScript",
    },
    RuleId: "32fa0d8e-8451-48e5-bc35-1ce9d04a41e3",
    RuleName: "check for validator file",
    RuleType: "File Exist",
    Type: "AWS-RunPowerShellScript",
    desiredStateRuleFilesCheck: {
      isUpdated: true,
      path: ["C:\\validator.txt"],
      removeClone: [false],
    },
    desiredStateRuleWindowsRegistry: {},
    remediationEnabled: true,
    remediationScript: {
      commands: "cd ..",
      executionTimeout: "1",
    },
    switchDssRuleOs: true,
    windowsScript: true,
  },
];
